import React, { useState } from 'react';

import { SS_KEY_HIDE_REMINDER } from 'common/constants/LocalStorageKeys';
import trans from 'common/tools/translations/trans';
import { getResendConfirmationEmailUrl } from 'common/tools/userspace';

import Message from 'website/components/message-board/Message';

const AccountConfirmationMessage = () => {
  const [hidden, setHidden] = useState(false);

  const dismiss = () => {
    sessionStorage.setItem(SS_KEY_HIDE_REMINDER, 'true');
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <Message onClick={dismiss}>
      <div className="message-content">
        <p className="main-text">
          {trans('userspace.account-confirmation-message.title')}
        </p>
        <p className="sub-text">
          {trans('userspace.account-confirmation-message.text1')}
        </p>
        <p className="sub-text">
          {trans('userspace.account-confirmation-message.text2')}{' '}
          <a
            className="link"
            style={{ cursor: 'pointer' }}
            href={getResendConfirmationEmailUrl(window.location.href)}
          >
            {trans('userspace.account-confirmation-message.link')}
          </a>
        </p>
      </div>
      <button type="button" className="button button-message" onClick={dismiss}>
        {trans('userspace.account-action.success.button-text')}
      </button>
    </Message>
  );
};

export default AccountConfirmationMessage;
